import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i265267388__a)" }, [
      _createElementVNode("path", {
        fill: "#033CAA",
        d: "M.578 10.807c-.02-.02-.169-.598-.332-1.286s-.271-1.259-.24-1.268c.03-.01.521-.08 1.092-.158 1.147-.157 2.486-.536 3.323-.94C7.03 5.893 8.758 3.63 9.207.885l.114-.7h2.305l.11.634c.717 4.151 3.913 6.858 8.696 7.364.313.033.568.072.568.088 0 .14-.576 2.46-.621 2.503-.033.032-.326.008-.65-.052-3.597-.672-6.523-2.594-7.747-5.088l-.294-.598-.023-.164-.014.262H9.318l-.015-.282-.023.193-.394.755C7.864 7.76 5.86 9.311 3.167 10.225c-.767.26-2.515.653-2.59.582"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i265267388__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h21v11H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "faq-arrow"}) } }